export default __webpack_public_path__ + "4d56de51fe065f646982b5e654cae696.png";